import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { EventsService } from 'src/app/services/events-service/events.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-events-events-resume-card',
  templateUrl: './events-events-resume-card.component.html',
  styleUrls: ['./events-events-resume-card.component.scss']
})
export class EventsEventsResumeCardComponent implements OnInit, OnDestroy {

  @Input() alert;
  @Input() viewDisposition;
  centerList;
  updateAlertStatusSubscription: Subscription;
  deleteAlertSubscription: Subscription;

  constructor( private userStorageService: UserStorageService,
    private eventsService: EventsService,
    private snackbarService: SnackBarService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
  }

  public toggleStatus() {
    this.updateAlertStatusSubscription = this.eventsService.updateAlertStatus(this.alert.InternalId).pipe(
      tap(o => this.alert.Active = o['data']['status']),
      tap(o => this.snackbarService.open(o['data']['message'], 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['../event', this.alert.InternalId], { relativeTo: this.activatedRoute.parent });
    }
  }

  public deleteAlert() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['events-page.delete event', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteAlertSubscription = this.eventsService.deleteAlert(this.alert.InternalId).pipe(
          tap(o => this.eventsService.refreshAlerts()),
          catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
        ).subscribe();
      }
    });
  }

  public getAssignedContacts() {
    if (this.alert && this.alert.CenterAlertContacts) {
      return this.alert.CenterAlertContacts.length;
    }
  }
  public getAlertDeviceList() {
    if (this.alert && this.alert.CenterAlertDeviceList) {
      return this.alert.CenterAlertDeviceList.length;
    }
  }
  public getAlertCapacityList() {
    if (this.alert && this.alert.CenterAlertCapacityList) {
      return this.alert.CenterAlertCapacityList.length;
    }
  }

  ngOnDestroy() {
    if (this.deleteAlertSubscription) { this.deleteAlertSubscription.unsubscribe(); }
  }
}
